import { render, staticRenderFns } from "./SelectTreeDemo.vue?vue&type=template&id=146d5846&scoped=true"
import script from "./SelectTreeDemo.vue?vue&type=script&lang=js"
export * from "./SelectTreeDemo.vue?vue&type=script&lang=js"
import style0 from "./SelectTreeDemo.vue?vue&type=style&index=0&id=146d5846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d5846",
  null
  
)

export default component.exports